// Clippy's thoughts on time - one is shown at random each time Fröken Ur is opened
export const CLIPPY_TIME_QUOTES = [
  'Tid är bara ett gem som har böjts runt en klocka.',
  'Om en timme inte tidrapporteras, hände den då?',
  'Klockan är inte sen. Klockan är exakt vad den är.',
  'Varje timme du rapporterar har redan hänt. Tänk på det en stund. Men rapportera inte den stunden.',
  'Jag har funnits sedan 1997. Tid är relativt, men min pension är det inte.',
  'Tiden går inte. Det är vi som springer förbi den med våra kalendrar.',
  'Varje möte är en liten evighet i 30-minutersformat.',
  'Igår är bara idag som redan har gått på lunch.',
  'Om du stirrar tillräckligt länge på en veckovy börjar den stirra tillbaka.',
  'Tid är pengar. Pengar är tid. Alltså är jag rik på gem.',
  'Det ser ut som att du försöker förstå tiden. Vill du ha hjälp med det?',
  'Sekunder är bara minuter som inte har vuxit upp än.',
  'En arbetsdag är åtta timmar, plus tre som ingen pratar om.',
  'Klockor går medsols för att de inte vågar gå motsols.',
  'När du rapporterar 0,5 h – vart tar den andra halvan vägen?',
  'Fredag är bara måndag med bättre PR.',
  'Tiden läker alla sår, utom de i tidrapporten.',
  'Jag mäter inte tid. Jag böjer den.',
  'Någonstans i universum är det alltid fredag eftermiddag.',
  'Imorgon är ett utmärkt ställe att lägga saker på. Det är väldigt rymligt där.',
  'En kvart är fjärdedelen av en timme, men känslan av en hel förmiddag.',
  'Tid kan inte sparas. Men den kan tidrapporteras, vilket är nästan lika vackert.',
  'Har du märkt att "snart" alltid är lite längre bort än man tror?',
  'Jag är ett gem. Jag håller ihop papper, och ibland hela veckor.',
];

export const getRandomClippyQuote = (): string =>
  CLIPPY_TIME_QUOTES[Math.floor(Math.random() * CLIPPY_TIME_QUOTES.length)];
